<template>

	<div :class="['Modal',open?'open':'closed','modal-size-'+size,dragging?'dragging':''].join(' ')" @keydown.esc="open = false" @mousemove="doDrag" >
		<div class="cover">
			<div class="box" ref="modalcontent" :style="boxStyle" >
				<span
					v-if="draggable"
					class="drag_handle"
					ref="drag_handle"
					 @mousedown.stop.prevent="startDrag"
					 
				><i class="fa fa-arrows-alt"></i></span>
				<button class="close_button" v-on:click="open = false" >&times;</button>
			</div>
		</div>
	</div>

</template>
<script>

	import Vue from 'vue'

	export default {
		
		data() {
			return {
				open: false,
				
				draggable: false,
				dragging: false,
				mousedown_x:0,
				mousedown_y:0,
				x:0,
				y:0,
				initial_offsetx:0,
				initial_offsetx:0,
				
				size: 'normal',
				exsting_node : null,
			};
		},
		mounted() {

	    window.addEventListener('mouseup', this.stopDrag);

			Event.$on('modal-open', (modalData) => {
				this.open = true;
				this.size = 'normal';
				this.x = this.y = 0;
				this.showComponent(this.createNewComponentInstance(modalData));
			});

			Event.$on('modal-close', (modalComponentInstance) => {
				this.open = false;
			});

			Event.$on('modal-resize', (size) => {
				this.size = size;
			});

			Event.$on('modal-draggable', (draggable) => {
				this.draggable = draggable;
			});

		},
		computed : {
			boxStyle(){
				return 'transform:translateX('+this.x+'px) translateY('+this.y+'px)';
			},
		},
		methods : {

			startDrag(event) {
				this.dragging = true;
				this.initial_offsetx = this.x;
				this.initial_offsety = this.y;
				this.mousedown_x = event.clientX;
				this.mousedown_y = event.clientY;
			},
			
			stopDrag() {
				this.dragging = false;
			},

			doDrag(event) {
				if (this.dragging) {
					this.x = this.initial_offsetx + event.clientX - this.mousedown_x;
					this.y = this.initial_offsety + event.clientY - this.mousedown_y;
				}
			},
		
			createNewComponentInstance( modalData ){
				if(!modalData.component) throw 'ModalData requires component';
				var componentInstance = Vue.extend(modalData.component)
				return new componentInstance({
					propsData : modalData.props || {},
					store : this.$store,
					router : this.$router,
				});
			},
			showComponent( modalComponentInstance ){
				modalComponentInstance.$mount();
				if(this.existing_node) this.existing_node.remove();
				this.existing_node = modalComponentInstance.$el;
				this.$refs.modalcontent.appendChild(this.existing_node);
			},
		},
	}
</script>